import React from 'react';

import { LogIn } from '@atlaskit/navigation-system/top-nav-items/log-in';

import { NAVIGATION_CHANNEL } from '../../analytics';

import { type AccountMenuLoggedOutStateProps, logInTooltip } from './index';

export const AccountMenuLoggedOutStateNav4: React.ComponentType<AccountMenuLoggedOutStateProps> = ({
	testId,
	logInLink,
}) => (
	<LogIn
		testId={testId}
		href={logInLink}
		onClick={(event, analytics) => {
			analytics.update({ actionSubjectId: 'logInLink' }).fire(NAVIGATION_CHANNEL);
		}}
		label={logInTooltip}
	/>
);
